import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { URL_PARAM_KEYS } from "@/utils/utils";

const useReset = (requestsOn: boolean) => {
  const setSearchParams = useSearchParams()[1];
  const prevRequestsOnRef = useRef<boolean | null>(null);

  useEffect(() => {
    // Only clear tab-specific params when the active tab actually changes.
    if (prevRequestsOnRef.current !== null && prevRequestsOnRef.current !== requestsOn) {
      setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.delete(URL_PARAM_KEYS.METADATA);

        if (requestsOn) {
          // Returning to requests: clear trace-only search/filter params.
          params.delete(URL_PARAM_KEYS.TRACE_Q);
          params.delete(URL_PARAM_KEYS.RESOURCE);
        }

        return params;
      });
    }
    prevRequestsOnRef.current = requestsOn;
  }, [requestsOn, setSearchParams]);
};

export default useReset;
